<div
  [ngClass]="{'order-entry__panel-more__execution-mode__container': true,
			'order-entry__panel-more__execution-mode__container--checked': data.valueBoolean && !data.locked,
			'order-entry__panel-more__execution-mode__container--unchecked': !data.valueBoolean && !data.locked,
			'order-entry__panel-more__execution-mode__container--locked': data.locked}"
>
  <p-checkbox
    class="bfx-checkbox-bold-sm bfx-checkbox-bold-unsized"
    [label]="data.label"
    [binary]="true"
    [disabled]="data.locked || !data.enabled"
    [(ngModel)]="data.valueBoolean"
    (ngModelChange)="onValueChange()"
  >
  </p-checkbox>
</div>
